import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { loaiBangTotNghiepApi } from "../../../api/category/loaiBangTotNghiepApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eLoaiBangTotNghiepActionIds, ILoaiBangTotNghiepActionTypes } from "../../action-types/category/ILoaiBangTotNghiepActions";
import { IDmLoaiBangTotNghiep } from "../../../model/response/category/IDmLoaiBangTotNghiep";

const mainAction = rootActions.category.loaiBangTotNghiep;

export function* loaiBangTotNghiepSaga(): any {
    yield takeLatest(eLoaiBangTotNghiepActionIds.LOAD_START, loadWorker);
    yield takeEvery(eLoaiBangTotNghiepActionIds.SAVE_START, saveWorker);
    yield takeEvery(eLoaiBangTotNghiepActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
    const res = yield call(loaiBangTotNghiepApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải Loại bằng tốt nghiệp"));
    }
}

function* saveWorker(action: ILoaiBangTotNghiepActionTypes): any {
    const payload = action.payload as IDmLoaiBangTotNghiep;
    let res;
    if (payload.id_loaibangtn > 0) {
        res = yield call(loaiBangTotNghiepApi.Update, payload.id_loaibangtn, payload);
    } else {
        res = yield call(loaiBangTotNghiepApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(undefined));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu Loại bằng tốt nghiệp"));
    }
}

function* deleteWorker(action: ILoaiBangTotNghiepActionTypes): any {
    const id = action.payload as number;
    const res = yield call(loaiBangTotNghiepApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa Loại bằng tốt nghiệp"));
    }
}
